import { compose, withProps } from 'recompose';
import { withLabel } from '../../se/components/Label';
import NumberInput from '../../se/components/inputs/NumberInput';

export default compose(withLabel('Daily capacity in hours'), withProps({ placeholder: 'e.g., 8' }))(NumberInput);
